<template>
<div class="relative w-full">
    <div class="flex bg-white max-w-7xl rounded border mx-auto text-sm font-semibold h-20 -mt-10 z-1">
        <div class="flex w-1/4 p-2 justify-center items-center border-r">
            {{ proposal.client.name }}
        </div>
        <div class="flex w-1/4 p-2 justify-center items-center border-r">
            <svg
                width="18"
                height="17"
                class="mr-2"
                viewBox="0 0 18 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M1.5 4.33333C1.5 3.41286 2.24619 2.66667 3.16667 2.66667H14.8334C15.7539 2.66667 16.5 3.41286 16.5 4.33333V14.3333C16.5 15.2538 15.7539 16 14.8334 16H3.16667C2.24619 16 1.5 15.2538 1.5 14.3333V4.33333Z"
                    fill="white"
                />
                <path
                    d="M5.66668 4.33333V1M12.3334 4.33333V1M4.83334 7.66667H13.1667M3.16667 16H14.8334C15.7539 16 16.5 15.2538 16.5 14.3333V4.33333C16.5 3.41286 15.7539 2.66667 14.8334 2.66667H3.16667C2.24619 2.66667 1.5 3.41286 1.5 4.33333V14.3333C1.5 15.2538 2.24619 16 3.16667 16Z"
                    stroke="#212121"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
            <formatted-date-range :from="proposal.start_date" :to="proposal.end_date" />
        </div>
        <div class="flex w-1/4 p-2 justify-center items-center border-r">
            <svg
                width="18"
                height="17"
                class="mr-2"
                viewBox="0 0 18 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M16.5 8.5C16.5 12.6421 13.1422 16 9.00002 16C4.85787 16 1.5 12.6421 1.5 8.5C1.5 4.35786 4.85787 1 9.00002 1C13.1422 1 16.5 4.35786 16.5 8.5Z"
                    fill="white"
                />
                <path
                    d="M1.54577 7.66667H3.16667C4.08715 7.66667 4.83334 8.41286 4.83334 9.33333V10.1667C4.83334 11.0871 5.57954 11.8333 6.50002 11.8333C7.42049 11.8333 8.16669 12.5795 8.16669 13.5V15.9542M5.66668 1.7796V3.08333C5.66668 4.23393 6.59942 5.16667 7.75002 5.16667H8.16669C9.08716 5.16667 9.83336 5.91286 9.83336 6.83333C9.83336 7.75381 10.5796 8.5 11.5 8.5C12.4205 8.5 13.1667 7.75381 13.1667 6.83333C13.1667 5.91286 13.9129 5.16667 14.8334 5.16667L15.7204 5.16667M11.5 15.5732V13.5C11.5 12.5795 12.2462 11.8333 13.1667 11.8333H15.7204M16.5 8.5C16.5 12.6421 13.1422 16 9.00002 16C4.85787 16 1.5 12.6421 1.5 8.5C1.5 4.35786 4.85787 1 9.00002 1C13.1422 1 16.5 4.35786 16.5 8.5Z"
                    stroke="#212121"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
            {{ places_string }}
        </div>
        <div class="flex w-1/4 p-2 justify-center items-center">
            <button @click="open" class="rounded text-white text-sm px-3 py-1.5 bg-button-teal">
                Send proposal
            </button>
        </div>
    </div>
</div>
    <large-modal
        :show="show"
        title="Send proposal"
        subtitle="Send proposal to the customer. The proposal will be saved and locked to a specific version."
        @close="close"
        size="max-w-7xl"
        :footer="false"
    >
        <div class="w-full h-96 flex flex-col justify-between">
            <h3 class="text-2xl">Proposal Versions</h3>
          <div class="flex space-x-5">
            <div class="w-1/2">
              <spinning-circle v-if="loading" />
              <i v-if="versions.length === 0">No versions created</i>
              <div v-else class="overflow-scroll h-72 bg-white shadow sm:rounded-md">
                <ul role="list" class="divide-y divide-gray-200">
                  <li v-if="adding">
                    <div class="block hover:bg-gray-50">
                      <div class="flex items-center px-2 py-2 sm:px-3">
                        <div class="flex min-w-0 flex-1 items-center">
                          <div class="flex-shrink-0">
                            <img class="h-8 w-8 rounded-full object-cover " :src="$page.props.user.profile_photo_url" alt="">
                          </div>
                          <div class="flex flex-col px-4">
                            <div class="w-32 h-4 bg-gray-100"></div>
                            <div class="w-16 h-4 bg-gray-100 mt-1"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li v-for="version in versions.slice().reverse()" :key="version.id">
                    <div @click="selectVersion(version)" class="block cursor-pointer" :class="[selectedVersion?.id === version.id ? 'bg-yellow-100 hover:bg-yellow-200' : 'hover:bg-gray-50']">
                      <div class="flex items-center px-2 py-2 sm:px-3">
                        <div class="flex min-w-0 flex-1 items-center">
                          <div class="flex-shrink-0">
                            <img class="h-8 w-8 rounded-full object-cover " :src="version.creator.profile_photo_url" alt="">
                          </div>
                          <div class="min-w-0 flex-1 px-4 md:grid md:grid-cols-2 md:gap-4">
                            <div>
                              <p class="truncate text-sm font-medium text-indigo-600">
                                Created by {{ version.creator.name }}</p>
                              <p class="flex items-center text-sm text-gray-500">
                                <human-readable-time :date="version.created_at" prefix="" />
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="w-1/2 flex flex-col space-y-10">
              <template v-if="selectedVersion === null">
                <p>
                  Select a version on the left side.
                </p>
                <p>
                  You can also create a new version by clicking the button below.
                </p>

                <button @click="createProposalVersion" class="rounded text-white text-sm px-3 py-1.5 bg-icon">
                  Create new version
                </button>
              </template>
              <div v-else>
                <a :href="selectedVersion.url" target="_blank" class="text-indigo-600 hover:text-indigo-800">
                  {{selectedVersion.url}}
                </a>
              </div>

            </div>
          </div>
          <div>


            <button @click="close" class="rounded text-white text-sm px-3 py-1.5 bg-icon">
              Close
            </button>
          </div>
        </div>

    </large-modal>

</template>

<script setup>
import {computed, ref} from "vue";
import LargeModal from "@/ComponentsDeprecated/Modal/LargeModal";
import FormattedDateRange from "@/ComponentsDeprecated/Time/FormattedDateRange";
import SpinningCircle from "@/ComponentsDeprecated/Loaders/SpinningCircle";
import HumanReadableTime from "@/ComponentsDeprecated/Time/HumanReadableTime";
import {usePage} from "@inertiajs/vue3";

const show = ref(false)
const loading = ref(true)
const adding = ref(false)
const versions = ref([])
const selectedVersion = ref(null)

function open() {
  show.value = true
  axios.get(route('api.proposal.version.index', props.proposal.id))
    .then((response) => {
      versions.value = response.data
    })
    .catch((error) => {
      console.log(error)
    })
  .finally(() => {
    loading.value = false
  })
}
function close() {
    show.value = false
}

const props = defineProps({
    proposal: {
        type: Object,
        required: true
    }
})
const places_string = computed(() => {
    let places = [];
    props.proposal.places.forEach((place) => {
        places.push(place.name)
    })
    return places.join(' - ')
})

function selectVersion(version) {
  if(selectedVersion.value?.id === version.id) {
    selectedVersion.value = null
  }
  else selectedVersion.value = version
}

function createProposalVersion() {
  adding.value = true
    axios.post(route('api.proposal.version.store', props.proposal.id))
        .then((response) => {
          if(!response.data.duplicate) {
            versions.value.push(response.data.version)
          }
          selectedVersion.value = response.data.version
        })
        .catch((error) => {
            console.log(error)
        })
  .finally(() => {
    adding.value = false
  })
}
</script>
